<template>
    <div class="m-omitOrg">
        <el-form class="chart-query" :model="chartSearch" :inline="true" size="small">
            <el-form-item>
                <advanced-date-picker v-model="chartSearch.time"></advanced-date-picker>
            </el-form-item>
            <el-form-item>
                <el-button type="primary" @click="getChartData(1)" round>{{$t('c.query')}}</el-button>
            </el-form-item>
        </el-form>

        <el-row :gutter="20" class="mt10">
            <el-col :span="6">
                <div class="box-org">
                    <statistics-multi-orgs @orgsChange="orgsChange" @dataLoaded="orgDataLoaded"></statistics-multi-orgs>
                </div>
            </el-col>

            <el-col :span="18">
                <stats-chart ref="knowledgeChart" type="bar" title="各机构漏检图像数量和种类排行"></stats-chart>
            </el-col>
        </el-row>

        <el-row :gutter="20" class="mt10">
            <el-col :span="12" class="relative">
                <stats-chart ref="ageChart" type="bar" title="年龄段与漏检图像"></stats-chart>
            </el-col>

            <el-col :span="12">
                <stats-chart ref="genderChart" type="bar" title="性别与漏检图像"></stats-chart>
            </el-col>
        </el-row>

        <el-row :gutter="20" class="mt10">
            <el-col :span="12">
                <stats-chart ref="gradeChart" type="bar" title="岗位资质与漏检图像"></stats-chart>
            </el-col>

            <el-col :span="12">
                <stats-chart ref="flightNatureChart" type="bar" title="不同时间段漏检图像数量占比"></stats-chart>
            </el-col>
        </el-row>

        <ui-card class="table-box mt10" title="各机构漏检记录" icon="nucfont inuc-list-chart">
            <el-form class="table-query" :inline="true" size="mini">
                <!--组织机构-->
                <select-multi-orgs @orgsChange="formOrgsChange"></select-multi-orgs>
                <el-form-item label="漏检时间">
                    <advanced-date-picker v-model="formSearch.time" selector="select"></advanced-date-picker>
                </el-form-item>
                <el-form-item>
                    <el-button type="primary" @click="getTableData(1)" round>{{$t('c.query')}}</el-button>
                </el-form-item>
            </el-form>
            <data-tables class="omit-table"
                         :data="tableData"
                         :table-props="tableProps"
                         :current-page.sync="currentPage"
                         :page-size="20"
                         :pagination-props="{pageSizes: [20, 50, 100, 300, 500]}"
            >
                <el-table-column type="index" width="40" align="center"></el-table-column>
                <el-table-column v-for="(title, index) in titles" :prop="title.prop" :label="title.label" :key="index"
                                 align="center"
                                 show-overflow-tooltip
                                 :sortable="title.sortable">
                </el-table-column>
                <el-table-column :label="$t('c.operation')" align="center" width="140">
                    <div class="btn-cell" slot-scope="scope">
                        <i class="nucfont inuc-preview" :title="$t('c.view')" @click="viewOrgDetail(scope.row)"></i>
                    </div>
                </el-table-column>
            </data-tables>
        </ui-card>
    </div>
</template>

<script>
    import {Debounce} from '@/utils'
    import StatisticsMultiOrgs from '@/components/Statistics/StatisticsMultiOrgs'
    import SelectMultiOrgs from '@/components/SelectMultiOrgs'
    import AdvancedDatePicker from '@/components/DatePickerAdvanced'
    import uiCard from '@/components/Statistics/StatisticUICard'
    import StatsChart from "@/components/Statistics/StatsChart"

    export default {
        components: {
            StatisticsMultiOrgs,
            SelectMultiOrgs,
            AdvancedDatePicker,
            uiCard,
            StatsChart
        },

        data() {
            return {
                chartSearch: {
                    orgIds: [],
                    time: '',
                },

                formSearch: {
                    orgIds: [],
                    time: '',
                },
                tableData: [],
                tableProps: {
                    border: false,
                    stripe: true,
                    height: 360
                },
                currentPage: 1,
                titles: [
                    {
                        prop: 'name',
                        label: '机构'
                    }, {
                        prop: 'peopleNum',
                        label: '漏检人数',
                        sortable: 'custom'
                    }, {
                        prop: 'imageNum',
                        label: '漏检图像数量',
                        sortable: 'custom'
                    }, {
                        prop: 'knowledgeName',
                        label: '漏检图像最多种类',
                    }
                ],
            }
        },

        computed: {},

        mounted() {
            this.getTableData()
        },

        methods: {
            async getChartData() {
                let queryData = {
                    orgIds: this.chartSearch.orgIds,
                    startTime: this.chartSearch.time[0],
                    endTime: this.chartSearch.time[1],
                }

                this.$api.orgKnowledgeOmitTop(queryData).then(res => {
                    let data = res.package
                    this.$refs.knowledgeChart.drawChart({
                        category: data.xaxis.title,
                        series: this.getBarSeriesData(data),
                        reverse: true,
                        dataZoom: this.showDataZoom(data)
                    })
                })

                this.$api.orgAgeOmitTop(queryData).then(res => {
                    let data = res.package
                    this.$refs.ageChart.drawChart({
                        category: data.xaxis.title,
                        series: this.getBarSeriesData(data),
                        reverse: true,
                        dataZoom: this.showDataZoom(data)
                    })
                })

                this.$api.orgGenderOmitTop(queryData).then(res => {
                    let data = res.package
                    this.$refs.genderChart.drawChart({
                        category: data.xaxis.title,
                        series: this.getBarSeriesData(data),
                        reverse: true,
                        dataZoom: this.showDataZoom(data)
                    })
                })

                this.$api.orgGradeOmitTop(queryData).then(res => {
                    let data = res.package
                    this.$refs.gradeChart.drawChart({
                        category: data.xaxis.title,
                        series: this.getBarSeriesData(data),
                        reverse: true,
                        dataZoom: this.showDataZoom(data)
                    })
                })

                this.$api.orgFlightNatureTop(queryData).then(res => {
                    let data = res.package
                    this.$refs.flightNatureChart.drawChart({
                        category: data.xaxis.title,
                        series: this.getBarSeriesData(data),
                        reverse: true,
                        dataZoom: this.showDataZoom(data)
                    })
                })
            },

            getBarSeriesData(data) {
                let series = data.series.map(item => {
                    return {
                        name: item.name,
                        type: 'bar',
                        stack: 'number',
                        label: {
                            show: true,
                            position: 'insideRight',
                            fontSize: 14,
                            offset: [-10, 0],
                            // 将0变成''
                            formatter(params) {
                                return params.value && `${params.seriesName} ${params.value}` || ''
                            },
                        },
                        barMaxWidth: 40,
                        data: item.data
                    }
                })

                return series
            },

            // 是否展示缩放组件
            showDataZoom(data) {
                let length = data.xaxis.title.length
                console.log(length)

                if (length>5) {
                    return  [{
                        type: 'slider',
                        yAxisIndex: 0,
                        start: 40,
                        end: 100,
                    }]
                } else {
                    return []
                }
            },

            async getTableData(num) {
                if (num) this.currentPage = num

                let queryData = {
                    ...this.formSearch,
                    startTime: this.formSearch.time[0],
                    endTime: this.formSearch.time[1],
                }

                delete queryData.time

                let res = await this.$api.queryOrgOmit(queryData)
                this.tableData = res.package
            },

            viewOrgDetail({id, name}) {
                this.$router.push({name: 'omitOrgDetailStats', params: {orgID: id, name: name}})
            },

            orgDataLoaded() {
                this.$nextTick(() => {
                    $('.m-omitOrg .el-tree > .el-tree-node').eq(0).find('.el-checkbox:eq(0)').click()
                })
            },
            orgsChange: Debounce(function (data) {
                this.chartSearch.orgIds = data

                this.getChartData()
            }, 500),

            formOrgsChange(data) {
                this.formSearch.orgIds = data
            },
        },
    }
</script>

<style lang="scss">
    .m-omitOrg {

    }
</style>
